export enum TenantFeature {
  login = 'login',
  brokeragePlatformsMT4Swaps = 'brokeragePlatformsMT4Swaps',
  brokeragePlatformsMT5Swaps = 'brokeragePlatformsMT5Swaps',
  brokeragePlatformsMT5Sessions = 'brokeragePlatformsMT5Sessions',
  forgotPassword = 'forgotPassword',
  search = 'search',
  dashboard = 'dashboard',
  recordsAffiliates = 'recordsAffiliates',
  recordClients = 'recordsClients',
  recordsWallets = 'recordsWallets',
  clientTestFilledWindow = 'clientTestFilledWindow',
  clientEditTestFormWindow = 'clientEditTestFormWindow',
  clientNewTestFormWindow = 'clientNewTestFormWindow',
  recordsTradingAccounts = 'recordsTradingAccounts',
  recordsDemoAccounts = 'recordsDemoAccounts',
  recordsWelcomeAccounts = 'recordsWelcomeAccounts',
  recordsAccountGroups = 'recordsAccountGroups',
  recordsIntroducingBrokers = 'recordsIntroducingBrokers',
  recordsPaymentAgents = 'recordsPaymentAgents',
  recordLeads = 'recordsLeads',
  createLead = 'createLead',
  recordsExchangeRates = 'recordsExchangeRates',
  tickets = 'tickets',
  ticketsPayments = 'ticketsPayments',
  ticketsBackOffice = 'ticketsBackoffice',
  ticketsCompliance = 'ticketsCompliance',
  ticketsTranslation = 'ticketsTranslation',
  ticketsBrokerage = 'ticketsBrokerage',
  ticketsSales = 'ticketsSales',
  ticketsMyTickets = 'ticketsMyTickets',
  transactionWalletAdjustments = 'transactionWalletAdjustments',
  transactionWallet = 'transactionWallet',
  transactionPlatform = 'transactionPlatform',
  transactionDepositWithdrawal = 'transactionDepositWithdrawal',
  transactionIBCommissions = 'transactionIBCommissions',
  transactionIBCashBacks = 'transactionIBCashBacks',
  transactionIBCashbackSettings = 'transactionIBCashbackSettings',
  transactionBonus = 'transactionBonus',
  transactionPaymentAgent = 'transactionPaymentAgent',
  transactionTradingAccountAdjustments = 'transactionTradingAccountAdjustments',
  transactionBulkTransaction = 'transactionBulkTransaction',
  transactionBulkWithdrawals = 'transactionBulkWithdrawals',
  createTransaction = 'createTransaction',
  createETDTransaction = 'createETDTransaction',
  administrationUsers = 'administrationUsers',
  administrationUserTeams = 'administrationUserTeams',
  administrationSubscriptions = 'administrationSubscriptions',
  administrationPaymentProvidersConfig = 'administrationPaymentProvidersConfig',
  administrationPaymentProvidersOrdering = 'administrationPaymentProvidersOrdering',
  administrationRoles = 'administrationRoles',
  administrationTeams = 'administrationTeams',
  emails = 'emails',
  productVersions = 'productVersions',
  productFeatureFlags = 'productFeatureFlags',
  productPlatformVersions = 'productPlatformVersions',
  administrationCountries = 'administrationCountries',
  administrationWallets = 'administrationWallets',
  administrationTradingAccounts = 'administrationTradingAccounts',
  administrationProducts = 'administrationProducts',
  administrationAllowedPaymentProvidersMatrix = 'administrationAllowedPaymentProvidersMatrix',
  administrationAllowedPaymentProvidersUncovered = 'administrationAllowedPaymentProvidersUncovered',
  administrationRateMarkups = 'administrationRateMarkups',
  administrationPaymentControls = 'administrationPaymentControls',
  administrationPaymentControlsPSPCheckState = 'administrationPaymentControlsPSPCheckState',
  administrationMlWithdrawalAutomationGlobalControls = 'administrationMlWithdrawalAutomationGlobalControls',
  administrationMlWithdrawalAutomationOverrides = 'administrationMlWithdrawalAutomationOverrides',
  administrationWithdrawalThresholds = 'administrationWithdrawalThresholds',
  administrationTransactionProcessingMetrics = 'administrationTransactionProcessingMetrics',
  administrationInterestRateConfigControls = 'administrationInterestRateConfigControls',
  administrationInterestRateThresholds = 'administrationInterestRateThresholds',
  administrationInterestRateEligibility = 'administrationInterestRateEligibility',
  complianceCountryRisk = 'complianceCountryRisk',
  complianceWorldCheckCases = 'complianceWorldCheckCases',
  complianceAppropriatenessTests = 'complianceAppropriatenessTests',
  disclaimerLossPercentage = 'disclaimerLossPercentage',
  marketingCampaigns = 'marketingCampaigns',
  marketingNotifications = 'marketingNotifications',
  bonusModule = 'bonusModule',
  sglLinkGenerator = 'sglLinkGenerator',
  ibLanding = 'ibLanding',
  referralMaterials = 'referralMaterials',
  referralMaterialsCategories = 'referralMaterialsCategories',
  brokerageSwapFreeRating = 'brokerageSwapFreeRating',
  brokerageBulkRestrictions = 'brokerageBulkRestrictions',
  brokerageDeals = 'brokerageDeals',
  brokerageIBProfiles = 'brokerageIBProfiles',
  brokerageInstruments = 'brokerageInstruments',
  brokerageLeverages = 'brokerageLeverages',
  brokerageDividends = 'brokerageDividends',
  brokeragePlatforms = 'brokeragePlatforms',
  brokeragePlatformsConfiguration = 'brokeragePlatformsConfiguration',
  brokerageReferralsRestrictions = 'brokerageReferralsRestrictions',
  profileSettings = 'profileSettings',
  serverErrorServiceUnavailable = 'serverErrorServiceUnavailable',
  transactionUnsubscribeRequests = 'transactionUnsubscribeRequests',
  ibLandingPage = 'ibLandingPage',
  referralMaterialsPage = 'referralMaterialsPage',
  administrationPlatformLinks = 'administrationPlatformLinks',
  administrationContactDetails = 'administrationContactDetails',
  recordsCurrencyMarkups = 'recordsCurrencyMarkups',
  rewardTypeManager = 'rewardTypeManager',
  rewardPrograms = 'rewardPrograms',
}
